import 'dayjs/locale/pt-br';
import { Dayjs } from 'dayjs';
import Lottie from "lottie-react";
import { useForm } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { ProfileVersionEnum } from 'utils/enums';
import { LoadConfig } from 'utils/loadConfig';
import { ParsePerfilQuotation } from 'utils/parsePerfilQuotation';
import { FormDataVehicle, ParamsPageWebView, ParamsDataGetListarCotacoes } from 'utils/typeServices';
import { dataSex, dataCivilStatus, dataInsuredBondLegal, dataInsuredBondPhysical, dataTaxExemptionReason, dataVehicleUse, ParseVehicleUse, ParseTaxExemptionReason, ParseCivilStatus, ParseInsuredBond } from 'core/dataPerfilQuotation';
import { dataVehicleType, getVehicleUseByType, getVehicleActivity, isVehicleActivityRequired, getVehicleTypeByPlatformType, ParseVehicleType, ParseVehicleActivity } from 'core/dataProfileV2';

import Checkbox from '@mui/material/Checkbox';
import { Typography, Box, Fade, Collapse } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import Modals from 'components/views/Modals';
import Input from 'components/views/form/Input';
import NavTitle from 'components/views/NavTitle';
import Select from 'components/views/form/Select';
import PageErrors from 'components/views/PageErrors';
import FormVehicle from 'components/views/FormVehicle';
import ParseWebView from 'components/views/ParseWebView';
import RadioButton from 'components/views/form/RadioButton';
import { ButtonRectangle, ButtonOutlined } from 'components/views/form/Button';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

import { BoxFlex, BoxDataPicker, LinkExtermal } from './styles';

import loadingJson from 'assets/animation/loading_quotation.json';

type ParamsListDates = {
    date: string;
}

type ParamsArray = {
    text: string;
    value: string;
}

const Vehicle = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { state, pathname } = useLocation();
    const [isChassi, setIsChassi] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [enableButton, setEnableButton] = useState(true);
    const [isLegalPerson, setIsLegalPerson] = useState(false);
    const [showPageError, setShowPageError] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [errorPerfilEmpty, setErrorPerfilEmpty] = useState(false);
    const [completedProfile, setCompletedProfile] = useState(false);
    const [showModalIsFormCar, setShowModalIsFormCar] = useState(false);
    const [isShowModalColorCar, setIsShowModalColorCar] = useState(false);
    const [showExistActiveChanges, setShowExistActiveChanges] = useState<{ cD_COTACAO: number, cD_PESSOA: number } | false>();
    const [showModalExistActiveChanges, setShowModalExistActiveChanges] = useState(false);
    const [lastStepActiveChanges, setLastStepActiveChanges] = useState(false);
    const [listVersionsCar, setListVersionsCar] = useState<Array<ParamsArray>>([]);
    const [versionsCarSelected, setVersionsCarSelected] = useState<ParamsArray>();
    const [versionsColorSelected, setVersionsColorSelected] = useState<ParamsArray>();

    const [atWorkState, setAtWorkState] = useState(0);
    const [atSchoolOrcollegeState, setAtSchoolOrcollegeState] = useState(0);

    const [valueDate, setValueDate] = useState<Dayjs | null>(null);
    const [arrayListDates, setArrayListDates] = useState<Array<ParamsListDates>>([]);
    const { register, setValue, handleSubmit, watch, formState: { errors } } = useForm<FormDataVehicle>();

    const { selectedCar, formDataPerfil, dataPerfilUser, dataQuoteListservices, dataListarCotacoes, dataPostCancelChange, dataCar, isFormCar, dataVehicleTypeMismatch, handlePostQuoteListservices, handlePostQuotePlatform, handleGetListarCotacoes, handlePostCancelChange, handleClearVehicleTypeMismatch } = useContext(DataContext);

    const onError = (errors: Object) => {
        if (errors) {
            // SmoothScroll({ active: true, type: 'error', handlerChange: false });
        }
    }

    const handlePostCancelChangeState = () => {
        if (showExistActiveChanges) {
            setIsLoading(true);
            handlePostCancelChange(showExistActiveChanges);
        }
    }

    const onSubmit = (data: FormDataVehicle) => {
        if (Array.isArray(isFormCar) && !isFormCar[parseFloat(versionsCarSelected?.value || '0')]?.DS_COR && !colors) {
            setIsShowModalColorCar(true);
            return;
        }

        if (data && selectedCar && formDataPerfil) {
            setIsLoading(true);
            const dsPerfil = ParsePerfilQuotation({ FormDataPerfil: formDataPerfil, FormDataVehicle: data, newVersionQarActive });

            if (pathname?.includes('troca-de-veiculo')) {
                handlePostQuotePlatform({
                    body: {
                        customerId: selectedCar.CD_PESSOA,
                        cD_PEDIDO: selectedCar.CD_PEDIDO,
                        cD_CANAL_VENDA: 0,
                        dS_PLACA: formDataPerfil.chassisOrBoard.length > 7 ? '' : formDataPerfil.chassisOrBoard,
                        dS_CHASSI: formDataPerfil.chassisOrBoard.length > 7 ? formDataPerfil.chassisOrBoard : (chassis || ''),
                        cD_MODELO: modelId || 0,
                        nR_ANO: parseFloat(year || '0'),
                        nR_ANO_FABRICACAO: parseFloat(yearManufacture || '0'),
                        dS_COMBUSTIVEL: null,
                        dS_COR: colors || '',
                        fL_0KM: false,
                        ceP_PERNOITE: formDataPerfil.cep,
                        dS_PERFIL: dsPerfil,
                        nR_VERSAO_PERFIL: newVersionQarActive ? ProfileVersionEnum.NewVersion : ProfileVersionEnum.OldVersion,
                    },
                    isWebView
                });
            } else {
                handlePostQuoteListservices({
                    body: {
                        CD_PEDIDO: selectedCar?.CD_PEDIDO,
                        customerId: selectedCar?.CD_PESSOA,
                        ceP_PERNOITE: formDataPerfil.cep,
                        dS_PERFIL: dsPerfil,
                        nR_VERSAO_PERFIL: newVersionQarActive ? ProfileVersionEnum.NewVersion : ProfileVersionEnum.OldVersion
                    },
                    isWebView
                });
            }
        }
    }

    const handleParseGarage = (isGarage: string) => {
        switch (isGarage) {
            case 'Sim':
                return '1';
            case 'Não':
                return '0';
            case 'Não utiliza para ida à escola/faculdade':
                return '2';
            case "Não utiliza para ida ao trabalho":
                return '2';
            default:
                return '';
        }
    }

    const handleParseFormPerfilVehicle = () => {
        setCompletedProfile(true);
        if (dataPerfilUser) {
            setValue('vehicleUse', profileVehicleUseAvailable ? ParseVehicleUse(dataPerfilUser.UTILIZACAO_VEICULO) : { text: '', value: '' });
            setValue('minimumAge', dataPerfilUser.CONDUTOR_MENOR_26);
            setValue('mainConductor', dataPerfilUser.SEGURADO_PRINCIPAL_CONDUTOR);
            setValue('licenseTime', dataPerfilUser.TEMPO_HABILITACAO);

            setValue('nameConductor', dataPerfilUser.NOME_CONDUTOR);
            setValue('identityConductor', dataPerfilUser.CPF_CONDUTOR);
            setValue('sexConductor', {
                text: dataPerfilUser.SEXO_CONDUTOR === "M" ? "Masculino" : "Feminino",
                value: dataPerfilUser.SEXO_CONDUTOR === "M" ? "masculino" : "feminino",
            });
            setValue('civilStatusConductor', ParseCivilStatus(dataPerfilUser?.ESTADO_CIVIL_CONDUTOR.split('(')[0] || ''));
            setValue('insuredBond', ParseInsuredBond(dataPerfilUser.VINCULO_CONDUTOR_SEGURADO));
            setValue('birthDataConductor', dataPerfilUser.DATA_NASCIMENTO_CONDUTOR.match(Regex.birthData) ? dataPerfilUser.DATA_NASCIMENTO_CONDUTOR : '');

            const isNewVersionProfile = newVersionQarActive && dataPerfilUser.NR_VERSAO_PERFIL === ProfileVersionEnum.NewVersion;
            const modifiedOldVersion = dataPerfilUser.VEICULO_MODIFICADO === 'Sim' || dataPerfilUser.BLINDADO === 'Sim';

            setValue('vehicleType', ParseVehicleType(profileVehicleTypeValue || defaultVehicleType));
            setValue('vehicleActivity', ParseVehicleActivity(profileVehicleTypeValue || defaultVehicleType, profileVehicleUseValue, dataPerfilUser.ATIVIDADE_VEICULO || ''));
            setValue('vehicleArmored', isNewVersionProfile ? dataPerfilUser.VEICULO_BLINDADO === 'Sim' : modifiedOldVersion);
            setValue('vehicleLowered', isNewVersionProfile ? dataPerfilUser.VEICULO_REBAIXADO === 'Sim' : modifiedOldVersion);
            setValue('vehicleTuned', isNewVersionProfile ? dataPerfilUser.VEICULO_TUNADO === 'Sim' : modifiedOldVersion);
            setValue('equipped', modifiedOldVersion ? 'Sim' : 'Não');
            setValue('vehicleNoModifications', isNewVersionProfile
                ? dataPerfilUser.VEICULO_BLINDADO !== 'Sim' && dataPerfilUser.VEICULO_REBAIXADO !== 'Sim' && dataPerfilUser.VEICULO_TUNADO !== 'Sim'
                : !modifiedOldVersion);
            setValue('exemptionImpostor', dataPerfilUser.ISENCAO_IMPOSTO || 'Não');
            setValue('newCar', dataPerfilUser.ZERO_KM);
            setValue('gasKit', dataPerfilUser.VEICULO_KIT_GAS === '1' ? 'Sim' : 'Não');
            setValue('keptInGarage', dataPerfilUser.GARAGEM_FECHADA);
            setValue('transportToWork', dataPerfilUser.TRANSPORTE_TRABALHO);
            setValue('taxExemptionReason', ParseTaxExemptionReason(dataPerfilUser.MOTIVO_ISENCAO_FISCAL || ''));
            setValue('safeOwnerVehicle', dataPerfilUser.SEGURADO_PROPRIETARIO_LEGAL || 'Não');

            setValue('departureDealership', dataPerfilUser.SAIDA_CONCESSIONARIA || '');
            setValue('atHome', dataPerfilUser.GARAGEM_RESIDENCIA === 'Sim' ? true : false);
            setValue('atWork', handleParseGarage(dataPerfilUser.GARAGEM_TRABALHO));
            setAtWorkState(parseFloat(handleParseGarage(dataPerfilUser.GARAGEM_TRABALHO)));
            setValue('atSchoolOrcollege', handleParseGarage(dataPerfilUser.GARAGEM_FACULDADE));
            setAtSchoolOrcollegeState(parseFloat(handleParseGarage(dataPerfilUser.GARAGEM_FACULDADE)));

            // setValue('year',);
            // setValue('modelId',);
            // setValue('yearManufacture',);
            // setValue('chassis',);
        }
    }

    const vehicleUse = watch('vehicleUse');
    const minimumAge = watch('minimumAge');
    const mainConductor = watch('mainConductor');
    const licenseTime = watch('licenseTime');
    const nameConductor = watch('nameConductor');
    const identityConductor = watch('identityConductor');
    const sexConductor = watch('sexConductor');
    const civilStatusConductor = watch('civilStatusConductor');
    const insuredBond = watch('insuredBond');
    const birthDataConductor = watch('birthDataConductor');
    const vehicleType = watch('vehicleType');
    const vehicleActivity = watch('vehicleActivity');
    const vehicleNoModifications = watch('vehicleNoModifications');
    const vehicleArmored = watch('vehicleArmored');
    const vehicleLowered = watch('vehicleLowered');
    const vehicleTuned = watch('vehicleTuned');
    const newCar = watch('newCar');
    const gasKit = watch('gasKit');
    const keptInGarage = watch('keptInGarage');
    const transportToWork = watch('transportToWork');

    const newVersionQarActive = LoadConfig()?.NEW_VERSION_QAR_ACTIVE === true;
    const profileIsNewVersion = newVersionQarActive && (dataPerfilUser ? dataPerfilUser.NR_VERSAO_PERFIL === ProfileVersionEnum.NewVersion : false);
    const disableProfileV2Fields = completedProfile && profileIsNewVersion;
    const defaultVehicleType = 'passeio';
    const profileVehicleTypeValue = dataPerfilUser ? (dataPerfilUser.TIPO_VEICULO || getVehicleTypeByPlatformType(selectedCar?.CD_TIPO_PLATAFORMA)) : '';
    const profileVehicleUseValue = dataPerfilUser ? ParseVehicleUse(dataPerfilUser.UTILIZACAO_VEICULO).value : '';
    const vehicleUseOptionsFor = (tipo: string) => newVersionQarActive ? getVehicleUseByType(tipo) : dataVehicleUse;
    const profileVehicleUseAvailable = !!profileVehicleUseValue && vehicleUseOptionsFor(profileVehicleTypeValue || defaultVehicleType).some((item) => item.value === profileVehicleUseValue);
    const disableVehicleTypeAndUse = newVersionQarActive && completedProfile && !!profileVehicleTypeValue && profileVehicleUseAvailable;
    const vehicleUseOptions = vehicleUseOptionsFor(vehicleType?.value || '');
    const vehicleActivityOptions = getVehicleActivity(vehicleType?.value || '', vehicleUse?.value || '');
    const showVehicleActivity = newVersionQarActive && !!vehicleUse?.value && isVehicleActivityRequired(vehicleType?.value || '', vehicleUse?.value || '');
    const equipped = watch('equipped');
    const hasValidModification = newVersionQarActive
        ? !!(vehicleNoModifications || vehicleArmored || vehicleLowered || vehicleTuned)
        : !!equipped;

    const handleVehicleModification = (field: 'vehicleNoModifications' | 'vehicleArmored' | 'vehicleLowered' | 'vehicleTuned', checked: boolean) => {
        setValue(field, checked);

        if (!checked) {
            return;
        }

        if (field === 'vehicleNoModifications') {
            setValue('vehicleArmored', false);
            setValue('vehicleLowered', false);
            setValue('vehicleTuned', false);
            return;
        }

        setValue('vehicleNoModifications', false);
    }
    const exemptionImpostor = watch('exemptionImpostor');
    const taxExemptionReason = watch('taxExemptionReason');
    const safeOwnerVehicle = watch('safeOwnerVehicle');
    const departureDealership = watch('departureDealership');
    const atHome = watch('atHome');
    const year = watch('year');
    const modelId = watch('modelId');
    const yearManufacture = watch('yearManufacture');
    const chassis = watch('chassis');
    const colors = watch('colors');

    const handleNewDate = (newValue: Dayjs | null) => {
        setValueDate(newValue);
        newValue && setValue('departureDealership', newValue.format('DD/MM/YYYY'));
    };

    const handleIsAvailableDate = (dateDP: Dayjs) => {
        const isAvailable = arrayListDates?.some(({ date }) => date === dateDP.format('DD/MM/YYYY'));

        return !isAvailable;
    };

    const handleChangedName = (e: string) => {
        switch (e) {
            case '2ª':
                return 'Seg';
            case '3ª':
                return 'Ter';
            case '4ª':
                return 'Qua';
            case '5ª':
                return 'Qui';
            case '6ª':
                return 'Sex';
            default:
                return e;
        }
    };

    const handleIsAvailable = () => {
        let arrayList = [];
        const dataLast = new Date();
        dataLast.setDate(dataLast.getDate() + 20);

        for (let i = 0; i < 41; i++) {
            dataLast.setDate(dataLast.getDate() - 1);
            arrayList.push({ date: dataLast.toLocaleDateString('pt-BR') });
        }

        setArrayListDates(arrayList);
    }

    const handleSetDataFormVehicle = (e: { year: string; version: number; chassis: string; yearManufacture: string; color: string; }) => {
        setValue('year', e.year);
        setValue('modelId', e.version);
        setValue('yearManufacture', e.yearManufacture);
        setValue('chassis', e.chassis);
        setValue('colors', e.color);
    }

    const handleClosedEndScroll = () => {
        setShowModalIsFormCar(false);
        const boxMain = document?.getElementById('box-main');

        if (boxMain) {
            boxMain.scrollTop = document.body.scrollHeight;
        }
    }

    const handleSelectedCar = (e: ParamsArray) => {
        setVersionsCarSelected(e);

        if (Array.isArray(isFormCar)) {
            const modelSelected = isFormCar[parseFloat(e?.value)];

            setValue('year', `${modelSelected.NR_ANO}`);
            setValue('modelId', modelSelected.CD_MODELO);
            setValue('yearManufacture', `${modelSelected.NR_ANO_FABRICACAO}`);
            setValue('chassis', modelSelected.DS_CHASSI);
            setValue('colors', modelSelected?.DS_COR || '');
        }
    }

    useEffect(() => {
        if (arrayListDates.length === 0) {
            handleIsAvailable();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if ((!newVersionQarActive || vehicleType?.value) && vehicleUse?.value && (!showVehicleActivity || vehicleActivity?.value) && minimumAge && (mainConductor || isLegalPerson) && licenseTime) {
            if (hasValidModification && newCar && gasKit && keptInGarage) {
                setEnableButton(false);

                if (vehicleUse?.value === 'parceiros') {
                    if (transportToWork) {
                        setEnableButton(false);
                    } else {
                        setEnableButton(true);
                    }
                }

                if (vehicleUse?.value !== 'taxi') {
                    if (exemptionImpostor === 'Sim') {
                        if (taxExemptionReason) {
                            setEnableButton(false);
                        } else {
                            setEnableButton(true);
                            return;
                        }
                    } else if (exemptionImpostor === 'Não') {
                        setEnableButton(false);
                    } else {
                        setEnableButton(true);
                        return;
                    }
                }

                if (vehicleUse?.value === 'motorista_app' || vehicleUse?.value === 'taxi') {
                    if (safeOwnerVehicle) {
                        setEnableButton(false);
                    } else {
                        setEnableButton(true);
                        return;
                    }
                }

                if (newCar === 'Sim') {
                    if (departureDealership) {
                        setEnableButton(false);
                    } else {
                        setEnableButton(true);
                    }
                }

                if (keptInGarage === 'Sim') {
                    setEnableButton(true);
                    if (atHome || atWorkState === 1 || atSchoolOrcollegeState === 1) {
                        setEnableButton(false);
                    }
                }
            }
        } else {
            setEnableButton(true);
        }

    }, [isLegalPerson, atWorkState, atSchoolOrcollegeState, newVersionQarActive, vehicleType, vehicleActivity, showVehicleActivity, hasValidModification, vehicleUse, minimumAge, mainConductor, licenseTime, newCar, gasKit, keptInGarage, nameConductor, identityConductor, birthDataConductor, sexConductor, civilStatusConductor, insuredBond, transportToWork, exemptionImpostor, taxExemptionReason, safeOwnerVehicle, departureDealership, atHome, year, modelId, yearManufacture, chassis]);

    useEffect(() => {
        if (vehicleUse?.value === 'taxi') {
            setValue('transportToWork', 'Sim');
            setValue('exemptionImpostor', 'Sim');
            setValue('taxExemptionReason', { text: 'taxi', value: 'taxi' });
            setValue('atWork', '0');
        }

        if (!completedProfile) {
            if (vehicleUse?.value === 'taxi') {
                setValue('atWork', '0');
            } else if (vehicleUse?.value === 'comercial' || vehicleUse?.value === 'particular') {
                setValue('safeOwnerVehicle', '');
                setValue('transportToWork', 'Sim');
                setValue('taxExemptionReason', { text: '', value: '' });

                if (vehicleUse?.value === 'particular') {
                    setValue('transportToWork', '');
                }

                if (vehicleUse?.value === 'comercial') {
                    setValue('atWork', '2');
                }
            } else if (vehicleUse?.value === 'motorista_app') {
                setValue('atWork', '0');
                setValue('transportToWork', 'Sim');
                setValue('taxExemptionReason', { text: '', value: '' });
            } else {
                setValue('transportToWork', 'Sim');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicleUse]);

    useEffect(() => {
        if (!isVehicleActivityRequired(vehicleType?.value || '', vehicleUse?.value || '')) {
            setValue('vehicleActivity', { text: '', value: '' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicleType, vehicleUse]);

    useEffect(() => {
        if (!completedProfile) {
            if (newCar === 'Não') {
                setValueDate(null);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newCar]);

    useEffect(() => {
        if (!completedProfile) {
            if (exemptionImpostor === 'Não') {
                setValue('taxExemptionReason', { text: '', value: '' });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exemptionImpostor]);

    useEffect(() => {
        if (!completedProfile) {
            if (transportToWork === 'Não') {
                setValue('atWork', '2');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transportToWork]);

    useEffect(() => {
        if (!completedProfile) {
            if (mainConductor) {
                setValue('nameConductor', '');
                setValue('identityConductor', '');
                setValue('birthDataConductor', '');
                setValue('sexConductor', { text: '', value: '' });
                setValue('civilStatusConductor', { text: '', value: '' });
                setValue('insuredBond', { text: '', value: '' });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mainConductor]);

    useEffect(() => {
        if (!completedProfile) {
            if (formDataPerfil?.identity) {
                setIsLegalPerson(Regex.isCnpjIdentity(formDataPerfil?.identity));
                setValue('mainConductor', '');
            }

            if (formDataPerfil?.chassisOrBoard && formDataPerfil?.chassisOrBoard.length > 8) {
                setIsChassi(true);
                setValue('newCar', 'Sim');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formDataPerfil]);

    useEffect(() => {
        if (!formDataPerfil) {
            setErrorPerfilEmpty(true);
        }

        if (!state?.sameProfile) {
            setValue('vehicleNoModifications', true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (state?.sameProfile && dataPerfilUser && !completedProfile) {
            handleParseFormPerfilVehicle();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, dataPerfilUser, selectedCar]);

    useEffect(() => {
        if (typeof dataQuoteListservices !== 'undefined') {
            setIsLoading(false);
        }

        if (dataQuoteListservices === false && !dataVehicleTypeMismatch) {
            // setShowModalError(true);
            if (typeof isFormCar === 'undefined') {
                setShowPageError(true);
            } else {
                setShowModalIsFormCar(true);
                if (Array.isArray(isFormCar)) {
                    setListVersionsCar(isFormCar?.map(({ NM_VERSAO }, index) => ({ text: NM_VERSAO, value: `${index}` })));
                }
            }
        }
    }, [dataQuoteListservices, isFormCar, dataVehicleTypeMismatch]);

    useEffect(() => {
        if (!dataListarCotacoes && localStorage.getItem('token') && selectedCar) {
            handleGetListarCotacoes(selectedCar.NR_CNPJ_CPF);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, localStorage.getItem('token')]);

    useEffect(() => {
        if (dataListarCotacoes) {
            let dataListarCotacoesAux: Array<ParamsDataGetListarCotacoes> = [];
            let dataListarCotacoesAuxListWipe: Array<ParamsDataGetListarCotacoes> = [];

            dataListarCotacoes.map((value) => (dataListarCotacoesAux?.findIndex(({ NR_PLATAFORMA_ORIGEM }) => NR_PLATAFORMA_ORIGEM === value.NR_PLATAFORMA_ORIGEM) === -1) && dataListarCotacoesAux.push(value));

            // eslint-disable-next-line array-callback-return
            dataListarCotacoesAux.map(({ NR_PLATAFORMA_ORIGEM }) => {
                const filterAux = dataListarCotacoes.filter(({ NR_PLATAFORMA_ORIGEM: NR_PLATAFORMA_ORIGEM_LIST, NR_TIPO_COTACAO, STATUS_PEDIDO_COTACAO }) => ((NR_PLATAFORMA_ORIGEM_LIST === NR_PLATAFORMA_ORIGEM) && (NR_TIPO_COTACAO === 3) && (STATUS_PEDIDO_COTACAO < 5)));
                const filterAuxPlataform = dataListarCotacoes.filter(({ NR_PLATAFORMA_ORIGEM: NR_PLATAFORMA_ORIGEM_LIST, NR_TIPO_COTACAO, STATUS_PEDIDO_COTACAO }) => ((NR_PLATAFORMA_ORIGEM_LIST === NR_PLATAFORMA_ORIGEM) && (NR_TIPO_COTACAO === 4) && (STATUS_PEDIDO_COTACAO < 2)));

                if (filterAux?.length > 0) {
                    let max = filterAux.reduce((a, b) => {
                        return new Date(a.DT_COTACAO).getTime() > new Date(b.DT_COTACAO).getTime() ? a : b;
                    });

                    dataListarCotacoesAuxListWipe.push(max);
                }

                if (filterAuxPlataform?.length > 0) {
                    let max = filterAuxPlataform.reduce((a, b) => {
                        return new Date(a.DT_COTACAO).getTime() > new Date(b.DT_COTACAO).getTime() ? a : b;
                    });

                    dataListarCotacoesAuxListWipe.push(max);
                }
            });

            const typeQuotation = pathname?.includes('troca-de-servico');
            const typeQuotationOpen = dataListarCotacoesAuxListWipe?.find(({ NR_TIPO_COTACAO, NR_PLATAFORMA_ORIGEM }) => ((typeQuotation && (NR_TIPO_COTACAO === 3) && (NR_PLATAFORMA_ORIGEM === selectedCar?.NR_PLATAFORMA)) || (!typeQuotation && (NR_TIPO_COTACAO === 4) && (NR_PLATAFORMA_ORIGEM === selectedCar?.NR_PLATAFORMA))));

            typeQuotationOpen ? setShowExistActiveChanges({ cD_COTACAO: typeQuotationOpen.CD_COTACAO, cD_PESSOA: typeQuotationOpen.CD_PESSOA_ORIGEM }) : setShowExistActiveChanges(false);
            (typeQuotationOpen && ((typeQuotationOpen?.STATUS_PEDIDO_COTACAO >= 3) && (typeQuotationOpen?.STATUS_PEDIDO_COTACAO < 5))) && setLastStepActiveChanges(true);
        }
    }, [dataListarCotacoes, pathname, selectedCar]);

    useEffect(() => {
        if (dataPostCancelChange && selectedCar) {
            handleSubmit(onSubmit)();
            handleGetListarCotacoes(selectedCar.NR_CNPJ_CPF);
        } else if (dataPostCancelChange === false) {
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataPostCancelChange]);

    return (
        <ParseWebView stepActive={0} isWebView={isWebView} typePage='quotation'>
            <Fade in={isLoading}>
                <Box sx={{ display: isLoading ? 'flex' : 'none', marginTop: '20%', width: '100%', alignItems: 'center', flexDirection: 'column' }}>
                    <Typography fontSize='1.5625rem' fontWeight={700} color='primary.light'>
                        Buscando informações
                    </Typography>

                    <Box sx={{ padding: '1.5rem' }}>
                        <Lottie animationData={loadingJson} loop={true} />
                    </Box>

                    <Typography fontSize='.9375rem' lineHeight='.9375rem' textAlign='center'>
                        Aguarde enquanto buscamos as <br />
                        melhores oportunidades para o seu perfil
                    </Typography>
                </Box>
            </Fade>

            {showPageError &&
                <PageErrors isWebView={isWebView} />
            }

            <Fade in={(!isLoading || !showPageError)}>
                <Box sx={{ maxWidth: '40rem', margin: '0 auto', display: (isLoading || showPageError) ? 'none' : 'flex', flexDirection: 'column' }}>
                    <Typography sx={{ fontSize: '1.25rem', paddingBottom: '1.25rem', textAlign: 'center' }}>
                        <strong>Insira</strong> os seus dados principais e de sua cotação para prosseguimos:
                    </Typography>
                    <NavTitle title='Dados do veículo' />
                    <Box sx={{ margin: '1.25rem auto 0', maxWidth: '26rem', display: 'flex', flexDirection: 'column' }} className='content-form' component="form" onSubmit={handleSubmit(onSubmit, onError)}>
                        {newVersionQarActive &&
                        <Box sx={{ marginBottom: '2.06rem' }}>
                            <Select
                                label='Tipo de veículo'
                                placeholder='Selecione'
                                itemSelected={vehicleType}
                                listItems={dataVehicleType}
                                error={!vehicleType?.value || !!dataVehicleTypeMismatch}
                                disabled={disableVehicleTypeAndUse}
                                onChangeSelected={(e) => {
                                    handleClearVehicleTypeMismatch();
                                    setValue('vehicleType', e);
                                    setValue('vehicleUse', { text: '', value: '' });
                                    setValue('vehicleActivity', { text: '', value: '' });
                                }}
                            />
                            {dataVehicleTypeMismatch &&
                                <Typography variant='overline' sx={{ color: 'error.main', display: 'block', lineHeight: 1.4, marginTop: '.25rem' }}>
                                    {dataVehicleTypeMismatch}
                                </Typography>
                            }
                        </Box>
                        }

                        <Box sx={{ marginBottom: '2.06rem' }}>
                            <Select
                                label='Utilização do veículo'
                                placeholder='Selecione'
                                itemSelected={vehicleUse}
                                listItems={vehicleUseOptions}
                                error={vehicleUse?.value ? false : true}
                                disabled={(newVersionQarActive && !vehicleType?.value) || disableVehicleTypeAndUse}
                                onChangeSelected={(e) => {
                                    setValue('vehicleUse', e);
                                    setValue('vehicleActivity', { text: '', value: '' });
                                }}
                            />
                        </Box>

                        <Collapse in={showVehicleActivity}>
                            <Box sx={{ marginBottom: '2.06rem' }}>
                                <Select
                                    label='Atividade com o veículo'
                                    placeholder='Selecione'
                                    itemSelected={vehicleActivity}
                                    listItems={vehicleActivityOptions}
                                    error={vehicleActivity?.value ? false : true}
                                    disabled={disableProfileV2Fields}
                                    onChangeSelected={(e) => setValue('vehicleActivity', e)}
                                />
                            </Box>
                        </Collapse>
                        <RadioButton
                            text='Existe um condutor do veículo entre 18 e 26 anos?'
                            disabled={completedProfile}
                            listItems={[{
                                id: 'rule-yes',
                                name: 'minimumAge',
                                value: 'Sim'
                            },
                            {
                                id: 'rule-no',
                                name: 'minimumAge',
                                value: 'Não'
                            }]}
                            register={{ ...register("minimumAge") }}
                        />
                        {!isLegalPerson &&
                            <RadioButton
                                text='O segurado é o principal condutor?'
                                disabled={completedProfile}
                                listItems={[{
                                    id: 'rule-main-yes',
                                    name: 'mainConductor',
                                    value: 'Sim'
                                },
                                {
                                    id: 'rule-main-no',
                                    name: 'mainConductor',
                                    value: 'Não'
                                }]}
                                register={{ ...register("mainConductor") }}
                                textTooltip='Principal condutor é quem utiliza o veículo mais do que 1 vez na semana.'
                            />
                        }

                        <Collapse in={(mainConductor === 'Não' || isLegalPerson) ? true : false}>
                            <Box sx={{ paddingBottom: '2.06rem' }}>
                                <Typography sx={{
                                    fontSize: { xs: '1.25', md: '1.875rem' },
                                    fontWeight: { xs: 700, md: 400 },
                                    paddingBottom: { xs: '.75rem', md: '1.56rem' },
                                }}>
                                    Dados do Condutor
                                </Typography>
                                <Input
                                    name='nameConductor'
                                    label='Nome do condutor'
                                    placeholder='Nome'
                                    type='text'
                                    disabled={completedProfile}
                                    error={errors.nameConductor}
                                    textError="Insira nome e sobrenome"
                                    register={{ ...register("nameConductor", { pattern: Regex.name }) }}
                                />
                                <BoxFlex>
                                    <Input
                                        name='identityConductor'
                                        label='CPF do condutor'
                                        placeholder='999.999.999-99'
                                        type='tel'
                                        mask
                                        error={errors.identityConductor}
                                        textError="Insira um número válido"
                                        register={{ ...register("identityConductor", { pattern: Regex.identity }) }} />
                                    <Input
                                        name='birthDataConductor'
                                        label='Data de nascimento'
                                        placeholder='99/99/9999'
                                        type='tel'
                                        mask
                                        disabled={false}
                                        error={!birthDataConductor?.match(Regex.birthData)}
                                        register={{ ...register("birthDataConductor", { pattern: Regex.birthData }) }} />
                                </BoxFlex>

                                <BoxFlex>
                                    <Select
                                        label='Sexo do condutor'
                                        placeholder='Selecione'
                                        itemSelected={sexConductor}
                                        listItems={dataSex}
                                        disabled={completedProfile}
                                        onChangeSelected={(e) => setValue('sexConductor', e)}
                                    />
                                    <Select
                                        label='Estado civil do condutor'
                                        placeholder='Seleciona'
                                        itemSelected={civilStatusConductor}
                                        listItems={dataCivilStatus}
                                        disabled={completedProfile}
                                        onChangeSelected={(e) => setValue('civilStatusConductor', e)}
                                    />
                                </BoxFlex>

                                <Box sx={{ paddingTop: '1.37rem' }}>
                                    <Select
                                        label='Vínculo com o beneficiário'
                                        itemSelected={insuredBond}
                                        placeholder='Selecione'
                                        disabled={completedProfile}
                                        listItems={isLegalPerson ? dataInsuredBondLegal : dataInsuredBondPhysical}
                                        onChangeSelected={(e) => setValue('insuredBond', e)}
                                    />
                                </Box>
                            </Box>
                        </Collapse>

                        <RadioButton
                            width='9rem'
                            disabled={completedProfile}
                            text='O tempo de habilitação do principal condutor é de:'
                            listItems={[{
                                id: 'rule-license-time-small',
                                name: 'licenseTime',
                                value: 'Até 2 anos'
                            },
                            {
                                id: 'rule-license-time-larger',
                                name: 'licenseTime',
                                value: 'Mais que 2 anos'
                            }]}
                            register={{ ...register("licenseTime") }}
                        />
                        {!newVersionQarActive &&
                            <RadioButton
                                display='flex'
                                disabled={completedProfile}
                                text='Veículo blindado/rebaixado/tunado?'
                                listItems={[{
                                    id: 'rule-equipped-yes',
                                    name: 'equipped',
                                    value: 'Sim'
                                },
                                {
                                    id: 'rule-equipped-no',
                                    name: 'equipped',
                                    value: 'Não'
                                }]}
                                register={{ ...register("equipped") }}
                            />
                        }
                        {newVersionQarActive &&
                        <Box sx={{ paddingBottom: '1.37rem' }}>
                            <Typography variant='caption' sx={{ display: 'block', paddingBottom: '.62rem' }}>
                                Veículo possui alguma modificação?
                            </Typography>
                            <Box className='container-checkbox'>
                                <Box display='flex' alignItems='start' sx={{ minWidth: '10rem', height: '2.1rem', opacity: disableProfileV2Fields ? '.5' : '1' }}>
                                    <Checkbox sx={{ padding: '0 4px 0 0' }}
                                        disabled={disableProfileV2Fields}
                                        color='primary'
                                        checked={vehicleNoModifications || false}
                                        onChange={(e) => handleVehicleModification('vehicleNoModifications', e.target.checked)}
                                    />
                                    <Typography variant='caption' padding='6px 0'>
                                        Sem modificações
                                    </Typography>
                                </Box>
                                <Box display='flex' alignItems='start' sx={{ minWidth: '10rem', height: '2.1rem', opacity: disableProfileV2Fields ? '.5' : '1' }}>
                                    <Checkbox sx={{ padding: '0 4px 0 0' }}
                                        disabled={disableProfileV2Fields}
                                        color='primary'
                                        checked={vehicleArmored || false}
                                        onChange={(e) => handleVehicleModification('vehicleArmored', e.target.checked)}
                                    />
                                    <Typography variant='caption' padding='6px 0'>
                                        Blindado
                                    </Typography>
                                </Box>
                                <Box display='flex' alignItems='start' sx={{ minWidth: '10rem', height: '2.1rem', opacity: disableProfileV2Fields ? '.5' : '1' }}>
                                    <Checkbox sx={{ padding: '0 4px 0 0' }}
                                        disabled={disableProfileV2Fields}
                                        color='primary'
                                        checked={vehicleLowered || false}
                                        onChange={(e) => handleVehicleModification('vehicleLowered', e.target.checked)}
                                    />
                                    <Typography variant='caption' padding='6px 0'>
                                        Rebaixado
                                    </Typography>
                                </Box>
                                <Box display='flex' alignItems='start' sx={{ minWidth: '10rem', height: '2.1rem', opacity: disableProfileV2Fields ? '.5' : '1' }}>
                                    <Checkbox sx={{ padding: '0 4px 0 0' }}
                                        disabled={disableProfileV2Fields}
                                        color='primary'
                                        checked={vehicleTuned || false}
                                        onChange={(e) => handleVehicleModification('vehicleTuned', e.target.checked)}
                                    />
                                    <Typography variant='caption' padding='6px 0'>
                                        Tunado
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        }
                        {vehicleUse?.value !== 'taxi' &&
                            <RadioButton
                                display='flex'
                                disabled={completedProfile}
                                text='Veículo possui isenção de imposto?'
                                listItems={[{
                                    id: 'rule-exemptionImpostor-yes',
                                    name: 'exemptionImpostor',
                                    value: 'Sim'
                                },
                                {
                                    id: 'rule-exemptionImpostor-no',
                                    name: 'exemptionImpostor',
                                    value: 'Não'
                                }]}
                                register={{ ...register("exemptionImpostor") }}
                                textTooltip='Veículo adquirido com isenção de imposto (IPI/ICMS) independentemente da data da compra.'
                            />
                        }
                        {((exemptionImpostor === 'Sim') && (vehicleUse.value !== 'taxi')) &&
                            <Box sx={{ paddingBottom: '2.06rem' }}>
                                <Select
                                    placeholder='Selecione'
                                    label='Por qual motivo teve isenção de imposto?'
                                    itemSelected={taxExemptionReason}
                                    disabled={completedProfile}
                                    listItems={dataTaxExemptionReason}
                                    onChangeSelected={(e) => setValue('taxExemptionReason', e)}
                                />
                            </Box>
                        }
                        {!isChassi &&
                            <RadioButton
                                display='flex'
                                disabled={completedProfile}
                                text='Veículo 0Km?'
                                listItems={[{
                                    id: 'rule-newCar-yes',
                                    name: 'newCar',
                                    value: 'Sim'
                                },
                                {
                                    id: 'rule-newCar-no',
                                    name: 'newCar',
                                    value: 'Não'
                                }]}
                                register={{ ...register("newCar") }}
                                textTooltip='Veículo retirado da concessionária no prazo de até 20 dias.'
                            />
                        }
                        {(isChassi || newCar === 'Sim') &&
                            <Box>
                                <Typography variant="subtitle2" textAlign='start'>
                                    Data de saída da concessionária
                                </Typography>
                                <BoxDataPicker>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} localeText={{ previousMonth: 'Mês anterior', nextMonth: 'Próximo mês' }} adapterLocale='pt-br'>
                                        <DesktopDatePicker
                                            dayOfWeekFormatter={(day: string) => handleChangedName(day)}
                                            // inputFormat="DD/MM/YYYY"
                                            // mask='__/__/____'
                                            value={valueDate}
                                            onChange={(newValue) => {
                                                handleNewDate(newValue);
                                            }}
                                            shouldDisableDate={handleIsAvailableDate}
                                        // renderInput={(params) => <TextField {...params}
                                        //     inputProps={{
                                        //         ...params.inputProps,
                                        //         placeholder: "__/__/____"
                                        //     }}
                                        // />
                                        // }
                                        />
                                    </LocalizationProvider>
                                </BoxDataPicker>
                            </Box>
                        }
                        <RadioButton
                            display='flex'
                            disabled={completedProfile}
                            text='Veículo possui Kit gás?'
                            listItems={[{
                                id: 'rule-gasKit-yes',
                                name: 'gasKit',
                                value: 'Sim'
                            },
                            {
                                id: 'rule-gasKit-no',
                                name: 'gasKit',
                                value: 'Não'
                            }]}
                            register={{ ...register("gasKit") }}
                            textTooltip='O kit gás deve estar regularizado no documento do veículo.'
                        />
                        {(vehicleUse?.value === 'motorista_app' || vehicleUse?.value === 'taxi') &&
                            <RadioButton
                                text='Segurado é o proprietário legal do veículo?'
                                disabled={completedProfile}
                                listItems={[{
                                    id: 'rule-safeOwnerVehicle-yes',
                                    name: 'safeOwnerVehicle',
                                    value: 'Sim'
                                },
                                {
                                    id: 'rule-safeOwnerVehicle-no',
                                    name: 'safeOwnerVehicle',
                                    value: 'Não'
                                }]}
                                register={{ ...register("safeOwnerVehicle") }}
                            />
                        }
                        {vehicleUse?.value === 'particular' &&
                            <RadioButton
                                display='flex'
                                disabled={completedProfile}
                                text='Utiliza veículo como meio de transporte ao trabalho?'
                                listItems={[{
                                    id: 'rule-transportToWork-yes',
                                    name: 'transportToWork',
                                    value: 'Sim'
                                },
                                {
                                    id: 'rule-transportToWorkn-no',
                                    name: 'transportToWork',
                                    value: 'Não'
                                }]}
                                register={{ ...register("transportToWork") }}
                            />
                        }
                        <RadioButton
                            display='flex'
                            disabled={completedProfile}
                            text='Veículo fica guardado em garagem fechada ou estacionamento?'
                            listItems={[{
                                id: 'rule-keptInGarage-yes',
                                name: 'keptInGarage',
                                value: 'Sim'
                            },
                            {
                                id: 'rule-keptInGarage-no',
                                name: 'keptInGarage',
                                value: 'Não'
                            }]}
                            register={{ ...register("keptInGarage") }}
                        />
                        <Collapse in={keptInGarage === 'Sim'}>
                            <Box className='container-checkbox'>
                                <Box display='flex' alignItems='start' sx={{
                                    minWidth: '10rem',
                                    height: '2.1rem',
                                    opacity: completedProfile ? '.5' : '1'
                                }}>
                                    <Checkbox sx={{ padding: '0 4px 0 0' }}
                                        disabled={completedProfile}
                                        color='primary'
                                        {...register("atHome")}
                                    />
                                    <Typography variant='caption' padding='6px 0'>
                                        Na residência
                                    </Typography>
                                </Box>
                                {transportToWork === 'Sim' && vehicleUse?.value === 'particular' &&
                                    <Box display='flex' alignItems='center'
                                        sx={{
                                            opacity: completedProfile ? '.5' : '1'
                                        }}>
                                        <Box display='flex' alignItems='start' sx={{ minWidth: '10rem', height: '2.1rem' }}>
                                            <Checkbox
                                                color='primary'
                                                disabled={completedProfile}
                                                sx={{
                                                    padding: '0 4px 0 0'
                                                }}
                                                onClick={() => {
                                                    setAtWorkState(atWorkState === 1 ? 0 : 1);
                                                    setValue('atWork', atWorkState === 1 ? '0' : '1');
                                                }}
                                                checked={atWorkState === 1} />
                                            <Typography variant='caption' padding='6px 0'>
                                                No trabalho
                                            </Typography>
                                        </Box>
                                    </Box>
                                }
                                <Box display='flex' alignItems='center' sx={{
                                    opacity: completedProfile ? '.5' : '1'
                                }}>
                                    <Box display='flex' alignItems='start' sx={{ minWidth: '10rem', height: '2.1rem' }}>
                                        <Checkbox
                                            color='primary'
                                            disabled={completedProfile}
                                            sx={{ padding: '0 4px 0 0' }}
                                            onClick={() => {
                                                setAtSchoolOrcollegeState(atSchoolOrcollegeState === 1 ? 0 : 1);
                                                setValue('atSchoolOrcollege', atSchoolOrcollegeState === 1 ? '0' : '1');
                                            }}
                                            checked={atSchoolOrcollegeState === 1}
                                        />
                                        <Typography variant='caption' padding='6px 0'>
                                            Na escola/faculdade
                                        </Typography>
                                    </Box>
                                    <Box display='flex' alignItems='start' sx={{ height: '2.1rem' }}>
                                        <Checkbox
                                            color='primary'
                                            disabled={completedProfile}
                                            sx={{ padding: '0 4px 0 0' }}
                                            onClick={() => {
                                                setAtSchoolOrcollegeState(atSchoolOrcollegeState === 2 ? 0 : 2);
                                                setValue('atSchoolOrcollege', atSchoolOrcollegeState === 2 ? '0' : '2');
                                            }}
                                            checked={atSchoolOrcollegeState === 2}
                                        />
                                        <Typography variant='caption' padding='6px 0'>
                                            Não utiliza para ida à escola/faculdade
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography sx={{ textAlign: 'start', fontWeight: 600, marginTop: '1.37rem', fontSize: '.875rem' }}>
                                    * Selecione um local que o veículo fica guardado em garagem fechada ou estacionamento.
                                </Typography>
                            </Box>
                        </Collapse>
                        {dataCar &&
                            <FormVehicle handleReturnFormData={(e) => handleSetDataFormVehicle(e)} />
                        }
                        <Box sx={{ margin: '1.5rem 0 3rem', 'button': { width: '100%', height: '2.5rem' } }}>
                            {completedProfile ?
                                <ButtonRectangle
                                    name='FAZER COTAÇÃO PARA ESTE PERFIL'
                                    disabled={enableButton}
                                    type={showExistActiveChanges ? "button" : "submit"}
                                    onClick={() => showExistActiveChanges && setShowModalExistActiveChanges(true)}
                                />
                                :
                                <ButtonRectangle
                                    name='FAZER COTAÇÃO'
                                    disabled={enableButton}
                                    type={showExistActiveChanges ? "button" : "submit"}
                                    onClick={() => showExistActiveChanges && setShowModalExistActiveChanges(true)}
                                />
                            }
                        </Box>
                    </Box>

                    <Modals open={showModalIsFormCar}>
                        <Box sx={{ borderRadius: '8px', padding: '2rem', width: { xs: 'calc(100vw - 2rem)', md: '26rem' } }}>
                            {isFormCar === true ?
                                <>
                                    <Box sx={{
                                        width: '100%',
                                        height: '2.5rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        borderRadius: '40px',
                                        justifyContent: 'center',
                                        backgroundColor: 'primary.light'
                                    }}>
                                        <Typography fontWeight={700} color='white' fontSize='1.5rem'>
                                            Ops!
                                        </Typography>
                                    </Box>

                                    <Typography fontWeight={700} padding='1.5rem 0 2rem' textAlign='center' fontSize='1.125rem'>
                                        Não conseguimos encontrar o veículo, por favor nos informe os dados.
                                    </Typography>

                                    <ButtonOutlined
                                        name='Preencher'
                                        onClick={() => handleClosedEndScroll()}
                                    />
                                </>
                                :
                                <>
                                    <Box sx={{
                                        width: '100%',
                                        height: '2.5rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        borderRadius: '40px',
                                        justifyContent: 'center',
                                        backgroundColor: 'primary.light'
                                    }}>
                                        <Typography fontWeight={700} color='white' fontSize='1.5rem'>
                                            IMPORTANTE
                                        </Typography>
                                    </Box>

                                    <Typography fontWeight={400} padding='1.5rem 0 .5rem' textAlign='center' fontSize='1.125rem' maxWidth='18rem' margin='0 auto'>
                                        Para continuarmos <strong>selecione</strong> a versão do seu veículo!
                                    </Typography>

                                    <Select
                                        label='Versão'
                                        placeholder='Selecione'
                                        itemSelected={versionsCarSelected}
                                        listItems={listVersionsCar}
                                        onChangeSelected={(e) => handleSelectedCar(e)}
                                    />

                                    <Box sx={{ 'button': { width: '100%' }, marginTop: '2rem' }}>
                                        <ButtonRectangle
                                            name="CONTINUAR"
                                            disabled={versionsCarSelected ? false : true}
                                            onClick={() => { setShowModalIsFormCar(false); handleSubmit(onSubmit)(); }} />
                                    </Box>
                                </>
                            }
                        </Box>
                    </Modals>

                    <Modals open={isShowModalColorCar}>
                        <Box sx={{ borderRadius: '8px', padding: '2rem', width: { xs: 'calc(100vw - 2rem)', md: '26rem' } }}>
                            <Box sx={{
                                width: '100%',
                                height: '2.5rem',
                                display: 'flex',
                                alignItems: 'center',
                                borderRadius: '40px',
                                justifyContent: 'center',
                                backgroundColor: 'primary.light'
                            }}>
                                <Typography fontWeight={700} color='white' fontSize='1.5rem'>
                                    IMPORTANTE
                                </Typography>
                            </Box>

                            <Typography fontWeight={400} padding='1.5rem 0 .5rem' textAlign='center' fontSize='1.125rem' maxWidth='18rem' margin='0 auto'>
                                Para continuarmos <strong>selecione</strong> a cor do seu veículo!
                            </Typography>

                            <Select
                                label='Cor'
                                placeholder='Selecione'
                                itemSelected={versionsColorSelected}
                                listItems={dataCar?.colors?.map(({ DS_COR }, index) => {
                                    return {
                                        text: DS_COR, value: `${index}`
                                    }
                                }) || []}
                                onChangeSelected={(e) => { setVersionsColorSelected(e); setValue('colors', e.text) }}
                            />

                            <Box sx={{ 'button': { width: '100%' }, marginTop: '2rem' }}>
                                <ButtonRectangle
                                    name="CONTINUAR"
                                    disabled={versionsColorSelected ? false : true}
                                    onClick={() => { setIsShowModalColorCar(false); handleSubmit(onSubmit)(); }} />
                            </Box>
                        </Box>
                    </Modals>

                    <Modals open={errorPerfilEmpty}>
                        <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                            <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                                <Typography fontSize='1.5625rem' fontWeight={700}>
                                    ATENÇÃO!
                                </Typography>
                                <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                                    O primeiro formulario precisa ser preenchido
                                </Typography>
                            </Box>
                            <Box sx={{
                                borderRadius: '0 0 8px 8px',
                                padding: '1.875rem 3.81rem 1.75rem',
                                backgroundColor: 'primary.main',
                                'button': {
                                    width: '100%',
                                    height: '2.5rem',
                                    borderColor: 'white',
                                    color: 'white',
                                    ':hover': {
                                        color: 'white',
                                        borderColor: 'white',
                                    }
                                }
                            }}>
                                <ButtonOutlined name='Voltar' onClick={() => navigate(`${isWebView ? '/wb' : ''}/central-de-trocas/troca-de-servico/perfil`)} />
                            </Box>
                        </Box>
                    </Modals>

                    <Modals open={showModalError}>
                        <Box sx={{ borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: 'auto' } }}>
                            <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 2.56rem 1.25rem'>
                                <Typography fontSize='1.5625rem' fontWeight={700}>
                                    Central de Atendimento
                                </Typography>
                                <Typography fontSize='.875rem' lineHeight='17px' paddingTop='1rem'>
                                    Fale conosco através dos números abaixo:
                                </Typography>
                            </Box>
                            <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: { xs: '1rem 2.5rem 1.625rem', md: '1rem 3.8125rem 1.625rem' }, 'button': { width: '100%' } }}>
                                <Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                            São Paulo
                                        </Typography>
                                        <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                            Digite a opção 1,2
                                        </Typography>
                                    </Box>
                                    <LinkExtermal href="tel:1136169000">
                                        (011) 3616-9000
                                        <LocalPhoneOutlinedIcon />
                                    </LinkExtermal>
                                </Box>
                                <Box>
                                    <Typography fontSize='.75rem' color='white' paddingBottom='.2rem' textAlign='start'>
                                        Outras localidades
                                    </Typography>
                                    <LinkExtermal href="tel:08007742000">
                                        0800 774 2000
                                        <LocalPhoneOutlinedIcon />
                                    </LinkExtermal>
                                </Box>
                                <ButtonRectangle name='FECHAR' onClick={() => { setShowModalError(false); navigate(`${isWebView ? '/wb' : ''}/central-de-trocas`); }} />
                            </Box>
                        </Box>
                    </Modals>

                    <Modals open={showModalExistActiveChanges}>
                        <Box sx={{ borderRadius: '8px', textAlign: 'center', width: { xs: 'calc(100vw - 2rem)', md: '23.2rem' } }}>
                            <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1rem 1.25rem'>
                                <Typography fontSize='1.5625rem' fontWeight={700} lineHeight='30px'>
                                    ATENÇÃO!
                                </Typography>
                                {lastStepActiveChanges ?
                                    <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                                        Identificamos que você já possui uma troca em andamento.
                                    </Typography>
                                    :
                                    <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                                        Identificamos que você já possui uma troca em <b>andamento</b>, ao prosseguir com a nova troca, a anterior será <b>cancelada.</b>
                                    </Typography>
                                }
                            </Box>
                            <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: { xs: '1rem 2.5rem 1.625rem', md: '1rem 3.8125rem 1.625rem' }, 'button': { width: '100%' } }}>
                                {!lastStepActiveChanges &&
                                    <ButtonRectangle
                                        name='CONTINUAR'
                                        onClick={() => { handlePostCancelChangeState(); setShowModalExistActiveChanges(false); }}
                                    />
                                }
                                <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                                    <ButtonOutlined
                                        name='VER TROCAS'
                                        onClick={() => { setShowModalExistActiveChanges(false); navigate(`${isWebView ? '/wb' : ''}/central-de-trocas/trocas-em-andamento`); }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Modals>
                </Box>
            </Fade >
        </ParseWebView >
    );
}

export default Vehicle;